import { c as _c } from "react/compiler-runtime";
import { skillsIcons } from "@/constants/skills";
import s from "./ProductsCard.module.scss";
import { FashionImg, CampusDataImg, LExpressImg, LReactImg, TodoListImg, JavaImg, LandwindImg, LunaImg, MFImg, NotFound, RRImg, SpringImg } from "@/assets/imgs/export";
import Image from "next/image";
import Link from "next/link";
type ProjectsProps = {
  project: string;
  page: string;
};
type ProjectData = {
  title: string;
  description: string;
  projectImage: any;
  skills: string[];
  projectLink: string;
};
export default function ProjectsCard(t0) {
  const $ = _c(23);
  const {
    project,
    page
  } = t0;
  const getProjectData = _temp;
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== page || $[1] !== project) {
    const data = getProjectData(project);
    T0 = Link;
    t5 = data.projectLink;
    t6 = `${s[page]} ${s[project]} ${s.cardContainer}`;
    t7 = <div className={s.imageBG}><Image src={data.projectImage} alt={`${data.title}` + "-project-img"} priority={true} /></div>;
    t3 = s.cardInfo;
    t4 = <div className={s.cardTitleWrapper}><h3>{data.title}</h3><p>{data.description}</p></div>;
    t1 = s.skillsWrapper;
    t2 = data.skills.map(_temp2);
    $[0] = page;
    $[1] = project;
    $[2] = T0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    T0 = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t1 || $[11] !== t2) {
    t8 = <div className={t1}>{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t3 || $[14] !== t4 || $[15] !== t8) {
    t9 = <div className={t3}>{t4}{t8}</div>;
    $[13] = t3;
    $[14] = t4;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== T0 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t9) {
    t10 = <T0 href={t5} className={t6}>{t7}{t9}</T0>;
    $[17] = T0;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}
function _temp2(skill, i) {
  const Icon = skillsIcons[skill];
  if (!Icon) {
    return null;
  }
  return <Icon key={i} />;
}
function _temp(project_0) {
  switch (project_0) {
    case "luna":
      {
        return {
          title: "Luna",
          description: "Website + Figma Prototype",
          projectImage: LunaImg,
          skills: ["HTML", "CSS", "Spring", "MySQL"],
          projectLink: "https://github.com/ALunaProject"
        };
      }
    case "spring-project":
      {
        return {
          title: "Spring",
          description: "Simple SpringBoot projects monorepo",
          projectImage: SpringImg,
          skills: ["Java", "Spring"],
          projectLink: "https://github.com/LyanBrito/spring-project"
        };
      }
    case "todolist-back":
      {
        return {
          title: "Todo List",
          description: "To-do list project with Spring Boot",
          projectImage: TodoListImg,
          skills: ["Postman", "Spring", "MySQL", "Maven"],
          projectLink: "https://github.com/LyanBrito/todolist-back.java"
        };
      }
    case "campus-datacenter":
      {
        return {
          title: "Campus Datacenter",
          description: "OpenSource guide for SENAI's project",
          projectImage: CampusDataImg,
          skills: ["HTML", "CSS", "JavaScript", "Figma"],
          projectLink: "https://github.com/LyanBrito/campus-datacenter-explorer/tree/develop"
        };
      }
    case "learning-react":
      {
        return {
          title: "Learning React",
          description: "First react project",
          projectImage: LReactImg,
          projectLink: "https://github.com/LyanBrito/learning-react",
          skills: ["React", "JavaScript", "CSS"]
        };
      }
    case "express-study":
      {
        return {
          title: "Express API",
          description: "First express api made with Javascript",
          projectImage: LExpressImg,
          projectLink: "https://github.com/LyanBrito/learning-react",
          skills: ["Express.js", "JavaScript", "Postman"]
        };
      }
    case "java-course2":
      {
        return {
          title: "Java Course 2",
          description: "Basic Java exercised for POO practice",
          projectImage: JavaImg,
          projectLink: "https://github.com/LyanBrito/java-course2",
          skills: ["Java"]
        };
      }
    case "rr-html":
      {
        return {
          title: "R&R Funilaria",
          description: "Landing page for HTML practice",
          projectImage: RRImg,
          projectLink: "https://github.com/LyanBrito/SENAI-rrFunilaria.HTML",
          skills: ["HTML", "CSS", "Javascript"]
        };
      }
    case "shopping-react":
      {
        return {
          title: "Fashion Website",
          description: "Webshop landing page made with pure react",
          projectImage: FashionImg,
          projectLink: "https://github.com/LyanBrito/shopping-website.react",
          skills: ["React", "styled-component", "JavaScript"]
        };
      }
    case "landwind":
      {
        return {
          title: "Landwind LandinPage",
          description: "Page made with tailwind in Group",
          projectImage: LandwindImg,
          projectLink: "https://github.com/LyanBrito/code-dojo-landwind",
          skills: ["HTML", "CSS", "TailwindCSS"]
        };
      }
    case "microfront-study":
      {
        return {
          title: "Microfront Study",
          description: "Microfront-end study project with turborepo",
          projectImage: MFImg,
          projectLink: "https://github.com/LyanBrito/microfront-study.turborepo.git",
          skills: ["SCSS", "NextJS", "module-federation", "Turborepo"]
        };
      }
    default:
      {
        return {
          title: "Projeto n\xE3o encontrado",
          description: "Nenhuma informa\xE7\xE3o dispon\xEDvel.",
          projectImage: NotFound,
          projectLink: "",
          skills: []
        };
      }
  }
}